import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();
        this.setState({isOpen: false});
    }

    render({ logged_in, sale_price_code, kc_sale }) {
        const image_class = kc_sale ? ' kc-sale' : '';
        let ga_label = 'logged-out';

        if (logged_in) {
            ga_label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
        }

        return (
            <karmacoin-header>
                <header>
                    <div class={'icon-teeup icon-karma-coin-store' + image_class} />
                    <h1>Karma Coins<sup>®</sup> Store</h1>
                    <p>
                        Buy in bulk and get your favorite Tarot readings, Astrology reports, Numerology reports,
                        and I Ching readings for up to 50% off!
                        <a onClick={() => this.toggleAside(ga_label)}>Learn More</a>
                    </p>
                </header>
                {this.renderAside(ga_label)}
            </karmacoin-header>
        );
    }

    renderAside(ga_label) {
        if (this.state.isOpen) {
            return (
                <aside class='details'>
                    <a class='learn-more-close-button' onClick={() => this.toggleAside(ga_label)}>
                        x
                    </a>
                    <h3>What are Karma Coins?</h3>
                    <summary>
                        <p>
                            Karma Coins<sup>®</sup> (KCs for short) are digital credits used to purchase Tarot.com
                            products. What is the benefit of using KCs instead of cash? You receive a discount on
                            everything you purchase!
                        </p>
                    </summary>
                    <h3>Why Should I Use Karma Coins?</h3>
                    <summary>
                        <ul>
                            <li>Big Savings: Receive up to 50% OFF all your purchases when you buy in bulk</li>
                            <li>
                                One-Click: Skip the tedious credit card form and get right to your personalized insight!
                            </li>
                            <li>
                                Easy Tracking: Your KC balance is displayed at the top of each Tarot.com page for your
                                convenience
                            </li>
                        </ul>
                    </summary>
                    <h3>New To Karma Coins?</h3>
                    <summary>
                        <p>
                            As a first-time purchaser you will receive an additional 10% off your selected KC package.
                        </p>
                    </summary>
                </aside>
            );
        }

        return null;
    }

    toggleAside(label) {
        this.props.trackEvent(label);
        this.setState({isOpen: !this.state.isOpen});
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
    kc_sale: state['karmacoin-store'].kc_sale,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: label => dispatch({ type: 'ga:event', payload: [ 'kc-store', 'Click-Learn-More', label ] }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/karmacoin-store/karmacoin-header.js